/**
 * Фабрика in-flight дедупа. Оборачивает функцию-получатель по строковому ключу:
 * пока промис по ключу не завершился, повторные вызовы получают тот же промис
 * (один запрос вместо нескольких параллельных одинаковых). После завершения
 * запись снимается — поэтому это НЕ кэш и staleness исключён: следующий вызов
 * после завершения предыдущего идёт заново.
 *
 * Применение: на загрузке страницы разные точки кода (страница + виджет в
 * сайдбаре) параллельно дёргают один и тот же GET (installed?loaded=1) — вместо
 * двух сетевых запросов уходит один.
 */
export function createInflightDedup<R>(getter: (key: string) => Promise<R>): (key: string) => Promise<R> {
  const inflight = new Map<string, Promise<R>>();
  return (key: string): Promise<R> => {
    const existing = inflight.get(key);
    if (existing) return existing;
    const request = getter(key).finally(() => {
      inflight.delete(key);
    });
    inflight.set(key, request);
    return request;
  };
}
